angular.module 'zc.master.zcliteReports'

.controller 'MasterZcliteReportsListCtrl', (
    $scope,
    $translate,
    Page,
    SearchFilter,
    MasterInvoiceAdjustment,
    cronHours) ->

  Page.setBodyClass ''
  $translate('masterZclite.reports.list.siteList').then (translation) ->
    Page.setTitle translation

  $scope.projects = []
  $scope.filteredInvoiceAdjustments = []
  $scope.filters = []
  $scope.filters.sort_prop = "id"
  $scope.filters.sort_direction = "desc"

  aggregateBaseTime =
    moment()
    .subtract(cronHours.dailyReport, 'hours')
  $scope.currentPeriod =
    moment(aggregateBaseTime)
    .startOf('month')
    .toDate()
  maxPeriod =
    moment(aggregateBaseTime)
    .subtract(1, 'days')
    .startOf('month')
    .toDate()

  $scope.nextMonth = () ->
    return if $scope.currentPeriod >= maxPeriod
    $scope.currentPeriod = moment($scope.currentPeriod).add(1, 'month').toDate()
    getInvoiceAdjustments()

  $scope.prevMonth = () ->
    $scope.currentPeriod = moment($scope.currentPeriod).subtract(1, 'month').toDate()
    getInvoiceAdjustments()

  $scope.$on '$destroy', () ->
    SearchFilter.removeComponentDefaults 'masterProjectsList'

  $scope.setSortProp = (key) ->
    if $scope.filters.sort_prop == key
      if $scope.filters.sort_direction == 'desc'
        $scope.filters.sort_direction = 'asc'
      else
        $scope.filters.sort_direction = 'desc'
    else
      $scope.filters.sort_prop = key
      $scope.filters.sort_direction = 'desc'

    $scope.filterInvoiceAdjustments()

  $scope.filterInvoiceAdjustments = () ->
    $scope.filteredInvoiceAdjustments = _.chain $scope.invoice_adjustments
    .filter (adjustment) ->
      return false if adjustment.project.is_test or adjustment.project.is_demo
      return $scope.currentPeriod <= moment(adjustment.adjustment_date).toDate() < moment($scope.currentPeriod).add(1, 'month').toDate()
    .orderBy $scope.filters.sort_prop, $scope.filters.sort_direction
    .value()

    SearchFilter.updateComponentDefaults 'masterProjectsList'

  getInvoiceAdjustments = () ->
    MasterInvoiceAdjustment.all()
    .then (res) ->
      $scope.invoice_adjustments = res
      $scope.filterInvoiceAdjustments()

  getInvoiceAdjustments()

  $scope.completeAudit = (id) ->
    MasterInvoiceAdjustment.update(id, {
      invoice_adjustment:
        audited:
          true
    }).then (res) ->
      getInvoiceAdjustments()

  $scope.deleteInvoiceAdjustment = (id) ->
    MasterInvoiceAdjustment.destroy(id)
    .then (res) ->
      getInvoiceAdjustments()



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.zclite_reports/list.coffee